var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4096 20.4148C12.2106 20.6992 11.7894 20.6992 11.5904 20.4148L7.30071 14.2867C7.06874 13.9553 7.30582 13.5 7.71033 13.5H16.2897C16.6942 13.5 16.9313 13.9553 16.6993 14.2867L12.4096 20.4148Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4096 3.58517C12.2106 3.30081 11.7894 3.30081 11.5904 3.58517L7.30071 9.71327C7.06874 10.0447 7.30582 10.5 7.71033 10.5H16.2897C16.6942 10.5 16.9313 10.0447 16.6993 9.71327L12.4096 3.58517Z",
    fill: "#D8D3D3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesc);
export default __webpack_public_path__ + "static/media/desc.6c4df2fc208c806e5e2b55d34cec5ed3.svg";
export { ForwardRef as ReactComponent };